import { render, staticRenderFns } from "./MediaPicker.vue?vue&type=template&id=2741a7ae&scoped=true&"
import script from "./MediaPicker.vue?vue&type=script&lang=js&"
export * from "./MediaPicker.vue?vue&type=script&lang=js&"
import style0 from "./MediaPicker.vue?vue&type=style&index=0&id=2741a7ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2741a7ae",
  null
  
)

export default component.exports